/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A single invitation in the invitations list
 * @export
 * @interface InvitationItem
 */
export interface InvitationItem {
    /**
     * 
     * @type {string}
     * @memberof InvitationItem
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof InvitationItem
     */
    tournamentId?: string;
    /**
     * 
     * @type {string}
     * @memberof InvitationItem
     */
    teamId?: string;
    /**
     * 
     * @type {string}
     * @memberof InvitationItem
     */
    invitedUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof InvitationItem
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof InvitationItem
     */
    expiresAt?: number;
    /**
     * 
     * @type {number}
     * @memberof InvitationItem
     */
    createdAt?: number;
}

/**
 * Check if a given object implements the InvitationItem interface.
 */
export function instanceOfInvitationItem(value: object): value is InvitationItem {
    return true;
}

export function InvitationItemFromJSON(json: any): InvitationItem {
    return InvitationItemFromJSONTyped(json, false);
}

export function InvitationItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvitationItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tournamentId': json['tournamentId'] == null ? undefined : json['tournamentId'],
        'teamId': json['teamId'] == null ? undefined : json['teamId'],
        'invitedUserId': json['invitedUserId'] == null ? undefined : json['invitedUserId'],
        'status': json['status'] == null ? undefined : json['status'],
        'expiresAt': json['expiresAt'] == null ? undefined : json['expiresAt'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
    };
}

export function InvitationItemToJSON(json: any): InvitationItem {
    return InvitationItemToJSONTyped(json, false);
}

export function InvitationItemToJSONTyped(value?: InvitationItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tournamentId': value['tournamentId'],
        'teamId': value['teamId'],
        'invitedUserId': value['invitedUserId'],
        'status': value['status'],
        'expiresAt': value['expiresAt'],
        'createdAt': value['createdAt'],
    };
}

